export default function Work() {
  return <div></div>;
}
